
// import { createContext, useState, useEffect } from "react"
// import axios from 'axios'
// import { ToastContainer, toast,Slide, Zoom, Flip, Bounce,cssTransition } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import io from 'socket.io-client'



// export const UserContext = createContext();

// export const UserProvider = ({children}) => {
// const [userInfo, setUserinfo] = useState({});
// const [empid, setEmpid] = useState('');
// const [reset, setReset] = useState(false);
// const [spin, setSpin] = useState(false)
// const [userName, setUserName] = useState('')
// const [employees, setEmployees] = useState([])
// const [customers, setCustomers] = useState([])
// const [salesreps, setSalesreps] = useState([])



// useEffect(() => {

//   if(sessionStorage.getItem('trackuser')){

//     resetUser(sessionStorage.getItem('trackuser'))
//    // const getEmployee = async() => {
//     //  let rr = {"id":sessionStorage.getItem('trackuser')}
//     /*  await axios.post('https://cfpapi-6ab062006fa0.herokuapp.com/employee/getemployee',rr)
//       .then(res => {
//   console.log(res.data)
//         setUserinfo({...res.data,newname:res.data.preferredName+" "+res.data.lastName.charAt(0)})  
//       })
  
//       .catch(err => console.log(err))
//     }
//     getEmployee()
//     */
//   }
//   const getsales = async() => {
//     await axios.get('https://highgroundapi.herokuapp.com/employee/sales')
//    // await axios.get('http://localhost:5003/employee/sales')
//     .then(res => {setSalesreps(res.data)})
//     .catch(err => console.log(err))
// }

  
//   const getemployees = async() => {
//    await axios.get(`https://highgroundapi.herokuapp.com/employee/active`)
//    // await axios.get(`http://localhost:5003/employee/active`)
// .then(res => {setEmployees(res.data)})
// .catch(error => { console.log(error)})
// }
//   const getcustomers = async() => {
//   await axios.get(`https://highgroundapi.herokuapp.com/customers/all`)
//    // await axios.get(`http://localhost:5003/customers/all`)
// .then(res => {setCustomers(res.data)})
// .catch(error => { console.log(error)})
// }
// getemployees()
// getcustomers()
// getsales(0)
// },[spin])



// const updateEmployeeInfo = async() => {
//  // axios.post('https://cfpapi-6ab062006fa0.herokuapp.com/employee/update/employee',empinfo)
//  // .then(res => toast.success('Employee Updated'))
//  // .catch(err => console.log(err))
//  // console.log(empinfo)
// }

// const LoginCheck = async(info) => {

// if(!info?.username ){
//   return toast.error('Username can not be empty')
// }
// if(!info?.password ){
//   return toast.error('Password can not be empty')
//   }
// const r = {
//   "username":info.username,
//   "password":info.password,
// }

// await axios.post('https://highgroundapi.herokuapp.com/employee/login',r)
// .then(res => {
//   setUserinfo({...res.data.userinfo,fullName:res.data.userinfo?.preferredName+" "+res.data?.userinfo?.lastName?.charAt(0)});
// sessionStorage.setItem('trackuser',res.data.userinfo._id);
//  sessionStorage.setItem('fullName',res.data.userinfo?.preferredName+" "+res.data?.userinfo?.lastName?.charAt(0));
//  sessionStorage.setItem('page',res.data?.userinfo?.departments[0]?.label);
//  sessionStorage.setItem('eid',res.data?.userinfo?.empId);
//  let userName = sessionStorage.getItem('fullName')

//  // sessionStorage.setItem('access',res.data.userinfo.access);
//  // sessionStorage.setItem('empId',res.data.userinfo.empId);
// })
// .catch(err => {console.log(err);toast.error(err.response?.data?.message)})

// }

// const resetUser = async(id) => {
//   const t = await axios.get(`https://highgroundapi.herokuapp.com/employee/item/${id}`)
//   .then(res => {
//     setUserinfo({...res.data,fullName:res.data?.preferredName+" "+res.data?.lastName?.charAt(0)});
//     sessionStorage.setItem('trackuser',res.data._id);
//     sessionStorage.setItem('page',res.data?.departments[0]?.label);
//     sessionStorage.setItem('eid',res.data?.empId);                     
//  sessionStorage.setItem('fullName',res.data?.preferredName+" "+res.data?.lastName?.charAt(0));

//   })
//   .catch(err => console.log(err))

// }


// const logout = () => {
//   setUserinfo({})
//   sessionStorage.removeItem('trackuser')
//   sessionStorage.removeItem('fullName')
//   sessionStorage.removeItem('auth')
//   sessionStorage.removeItem('page');
// }

//   return (
//     <UserContext.Provider value={{userInfo,LoginCheck,setUserinfo,logout,spin,setSpin,resetUser,employees,customers,salesreps}}>
//          <ToastContainer position="top-center" theme="dark"  autoClose="500" hideProgressBar={true} transition={Flip} />
//         {children}
//     </UserContext.Provider>
//   )
// }

// export default UserContext 


import { createContext, useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';
import { ToastContainer, toast, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const UserContext = createContext();

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://highgroundapi.herokuapp.com';

export const UserProvider = ({ children }) => {
  const [userInfo, setUserinfo] = useState({});
  const [spin, setSpin] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [salesreps, setSalesreps] = useState([]);
  const [papers, setPapers] = useState([]);
  const [presses, setPresses] = useState([]);
  // Fetch initial data (employees, customers, sales reps)
  useEffect(() => {
    const fetchData = async () => {
      setSpin(true);
      try {
        const [employeesRes, customersRes, salesRes,papers,presslist] = await Promise.all([
          axios.get(`${API_BASE_URL}/employee/active`),
          axios.get(`${API_BASE_URL}/customers/all`),
          axios.get(`${API_BASE_URL}/employee/sales`),
          axios.get(`${API_BASE_URL}/paper/all`),
          axios.post("https://highgroundsoftware.com/dash/dashboard/php/getpresses.php",{headers:{'Content-Type':'application/json'}})

        ]);
   
        setEmployees(employeesRes.data);
        setCustomers(customersRes.data);
        setSalesreps(salesRes.data);
        setPapers(papers.data);
        setPresses(presslist.data);

      } catch (error) {
        console.error('Error fetching data:', error);
        toast.error('Failed to fetch data');
      } finally {
        setSpin(false);
      }
    };
    fetchData();
  }, []);

  // Load user from sessionStorage
  useEffect(() => {
    const trackuser = sessionStorage.getItem('trackuser');
    if (trackuser) {
      resetUser(trackuser);
    }
  }, []);

  const resetUser = useCallback(async (id) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/employee/item/${id}`);
      const user = res.data;
      setUserinfo({
        ...user,
        fullName: `${user.preferredName} ${user.lastName?.charAt(0)}`,
      });
      sessionStorage.setItem('trackuser', user._id);
      sessionStorage.setItem('page', user.departments[0]?.label);
      sessionStorage.setItem('eid', user.empId);
      sessionStorage.setItem('fullName', `${user.preferredName} ${user.lastName?.charAt(0)}`);
    } catch (error) {
      console.error('Error resetting user:', error);
      toast.error('Failed to load user data');
    }
  }, []);

  const LoginCheck = useCallback(async (info) => {
    const { username, password } = info || {};
    if (!username?.trim()) {
      return toast.error('Username cannot be empty');
    }
    if (!password?.trim()) {
      return toast.error('Password cannot be empty');
    }

    try {
      const res = await axios.post(`${API_BASE_URL}/employee/login`, {
        username: username.trim(),
        password: password.trim(),
      });
      const user = res.data.userinfo;
      setUserinfo({
        ...user,
        fullName: `${user.preferredName} ${user.lastName?.charAt(0)}`,
      });
      sessionStorage.setItem('trackuser', user._id);
      sessionStorage.setItem('fullName', `${user.preferredName} ${user.lastName?.charAt(0)}`);
      sessionStorage.setItem('page', user.departments[0]?.label);
      sessionStorage.setItem('eid', user.empId);
      toast.success('Login successful');
    } catch (error) {
      console.error('Login error:', error);
      toast.error(error.response?.data?.message || 'Login failed');
    }
  }, []);

  const logout = useCallback(() => {
    setUserinfo({});
    sessionStorage.removeItem('trackuser');
    sessionStorage.removeItem('fullName');
    sessionStorage.removeItem('auth');
    sessionStorage.removeItem('page');
    sessionStorage.removeItem('eid');
    toast.success('Logged out successfully');
  }, []);

  const contextValue = useMemo(
    () => ({
      userInfo,
      LoginCheck, // Restored as LoginCheck
      logout,
      resetUser,
      employees,
      customers,
      salesreps,
      spin,
      setSpin,
      papers,
      presses
    }),
    [userInfo, employees, customers, salesreps, spin, LoginCheck, logout, resetUser,papers,presses]
  );

  return (
    <UserContext.Provider value={contextValue}>
      <ToastContainer position="top-center" theme="dark" autoClose={500} hideProgressBar transition={Flip} />
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;